<form *ngIf="form" [formGroup]="form" (ngSubmit)="confirm(form)">
	<div class="main">
		<ng-container *ngIf="!!action">
			<ng-container *ngIf="!['DENY_ANNULMENT', 'CLARIFICATION'].includes(action)">
				<div>
					<div class="full-name">
						<b i18n class="required">Фамилия:</b>
						<app-textarea formControlName="lastName" maxLength="60" name="{{ getFieldTranslate('lastName') }}" [rows]="1"></app-textarea>
					</div>
					<div class="full-name">
						<b i18n class="required">Имя:</b>
						<app-textarea formControlName="firstName" maxLength="60" name="{{ getFieldTranslate('firstName') }}" [rows]="1"></app-textarea>
					</div>
					<div class="full-name">
						<b i18n>Отчество:</b>
						<app-textarea formControlName="middleName" maxLength="60" name="{{ getFieldTranslate('middleName') }}" [rows]="1"></app-textarea>
					</div>
				</div>
				<div>
					<b i18n class="required">Должность:</b>
					<app-textarea formControlName="jobPost" maxLength="1000" name="{{ getFieldTranslate('jobPost') }}" [rows]="1"></app-textarea>
				</div>
			</ng-container>
			<div>
				<b i18n class="required">Введите причину:</b>
				<app-textarea formControlName="reasonForCancellation" maxLength="1000" name="{{ checkErrorName() }}" [rows]="3"></app-textarea>
			</div>
			<span *ngIf="!['KZ', 'ME-RU'].includes(env.project) && certificateType === 'certificate'" class="default-label">{{ defaultHeader }}</span>
		</ng-container>
		<ng-container *ngIf="!['KZ', 'ME-RU'].includes(env.project) && (certificateType === 'certificate' || !action)">
			<div>
				<b i18n class="required">Логин:</b>
				<app-textbox formControlName="login" isDisabled=true></app-textbox>
			</div>
			<div>
				<b i18n class="required">Пароль:</b>
				<app-passwordbox formControlName="password" name="{{ getFieldTranslate('password') }}" [noTrimValue]="true"></app-passwordbox>
			</div>
		</ng-container>
	</div>
	<footer>
		<button class="save" appSkin="action-save bold">
			<ng-container *ngIf="!!action; else okTpl">
				<ng-container i18n>Подписать и отправить</ng-container>
			</ng-container>
			<ng-template #okTpl i18n>ОК</ng-template>
		</button>
		<button i18n type="button" class="save" appSkin="simple no-shadow bold bordered" (click)="close()">Закрыть</button>
	</footer>
</form>
